module.exports = __webpack_public_path__ + "site/img/45.c0a2937a.jpg";